import * as data from './data/philippines.json'


export const getProvinces = () => {
  const dataRegions = JSON.parse(JSON.stringify(data.regions))
  const regionsList: string[] = []
  // Metro Manila
  regionsList.push.apply(
    regionsList,
    Object.keys(dataRegions[16].province_list)
  )
  // Luzon
  regionsList.push.apply(
    regionsList,
    Object.keys(dataRegions[0].province_list)
  )
  regionsList.push.apply(
    regionsList,
    Object.keys(dataRegions[1].province_list)
  )
  regionsList.push.apply(
    regionsList,
    Object.keys(dataRegions[2].province_list)
  )
  regionsList.push.apply(
    regionsList,
    Object.keys(dataRegions[3].province_list)
  )
  regionsList.push.apply(
    regionsList,
    Object.keys(dataRegions[4].province_list)
  )
  regionsList.push.apply(
    regionsList,
    Object.keys(dataRegions[5].province_list)
  )
  regionsList.push.apply(
    regionsList,
    Object.keys(dataRegions[15].province_list)
  )
  // Visayas
  regionsList.push.apply(
    regionsList,
    Object.keys(dataRegions[6].province_list)
  )
  regionsList.push.apply(
    regionsList,
    Object.keys(dataRegions[7].province_list)
  )
  regionsList.push.apply(
    regionsList,
    Object.keys(dataRegions[8].province_list)
  )
  // Mindanao
  regionsList.push.apply(
    regionsList,
    Object.keys(dataRegions[9].province_list)
  )
  regionsList.push.apply(
    regionsList,
    Object.keys(dataRegions[10].province_list)
  )
  regionsList.push.apply(
    regionsList,
    Object.keys(dataRegions[11].province_list)
  )
  regionsList.push.apply(
    regionsList,
    Object.keys(dataRegions[12].province_list)
  )
  regionsList.push.apply(
    regionsList,
    Object.keys(dataRegions[13].province_list)
  )
  regionsList.push.apply(
    regionsList,
    Object.keys(dataRegions[14].province_list)
  )

  regionsList.sort()

  return regionsList
}

export const getMunicipalities = (region: number, province: string) => {
  const dataMunicipality = JSON.parse(JSON.stringify(data.regions[region].province_list))
  const municipalityList: any[] = []

  municipalityList.push.apply(
    municipalityList,
    Object.keys(dataMunicipality[province].municipality_list)
  )

  municipalityList.sort()

  return municipalityList
}


export const getBarangays = (region: number, province: any, municipality: any) => {
  const dataMunicipality = JSON.parse(JSON.stringify(data.regions[region].province_list))
  const dataBarangay = dataMunicipality[province].municipality_list[municipality].barangay_list

  dataBarangay.sort()

  return dataBarangay
}

export const getRegion = (province: string) => {
  const dataRegions = JSON.parse(JSON.stringify(data.regions))
  // Metro Manila
  if (Object.keys(dataRegions[16].province_list).includes(province)) return 16
  // Luzon
  if (Object.keys(dataRegions[0].province_list).includes(province)) return 0
  if (Object.keys(dataRegions[1].province_list).includes(province)) return 1
  if (Object.keys(dataRegions[2].province_list).includes(province)) return 2
  if (Object.keys(dataRegions[3].province_list).includes(province)) return 3
  if (Object.keys(dataRegions[4].province_list).includes(province)) return 4
  if (Object.keys(dataRegions[5].province_list).includes(province)) return 5
  if (Object.keys(dataRegions[15].province_list).includes(province)) return 15
  // Visayas
  if (Object.keys(dataRegions[6].province_list).includes(province)) return 6
  if (Object.keys(dataRegions[7].province_list).includes(province)) return 7
  if (Object.keys(dataRegions[8].province_list).includes(province)) return 8
  // Mindanao
  if (Object.keys(dataRegions[9].province_list).includes(province)) return 9
  if (Object.keys(dataRegions[10].province_list).includes(province)) return 10
  if (Object.keys(dataRegions[11].province_list).includes(province)) return 11
  if (Object.keys(dataRegions[12].province_list).includes(province)) return 12
  if (Object.keys(dataRegions[13].province_list).includes(province)) return 13
  if (Object.keys(dataRegions[14].province_list).includes(province)) return 14

}